import { BaseTransformationVisitor } from './baseTransformation.visitor';
import { MatchFunctionUtil } from '../utils/matchFunction.util';
import { SchemaUtil } from '../utils/schema.util';
import { ExpressionColumnPlainObject } from '../plainObjects/expressionColumn.plainObject';
import { AggregatePlainObject } from '../plainObjects/aggregate.plainObject';

/* eslint-disable @typescript-eslint/no-explicit-any */
export class AggregateVisitor extends BaseTransformationVisitor {
    private get _aggregateTransformation(): AggregatePlainObject {
        return this.transformation as AggregatePlainObject;
    }

    public visitAssignment(assignment: any): ExpressionColumnPlainObject {
        const aggColumn = new ExpressionColumnPlainObject();
        aggColumn.name = SchemaUtil.getColumnName(assignment.columnIdentifier());
        aggColumn.expression = this._getText(assignment.expression());
        this._aggregateTransformation.columns.push(aggColumn);
        return aggColumn;
    }

    public visitTransientAssignment(assignment: any): void {
        const visitAssignment = this.visitAssignment(assignment);
        visitAssignment.transient = true;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public visitBasicFunction(context: any): void {
        if (context.basicName().getText() === 'groupBy') {
            MatchFunctionUtil.addGroupByColumns(this._aggregateTransformation, context);
        }
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public visitMetaFunctionExpr(context: any): void {
        if (context.metafunction().basicName().getText() === 'groupBy') {
            MatchFunctionUtil.addGroupByColumns(
                this._aggregateTransformation, context.metafunction());
        } else if (context.metafunction().basicName().getText() === 'each') {
            MatchFunctionUtil.addColumnPatternColumns(this._aggregateTransformation, this._tokenStream, context);
        }
    }
}
